import axios from "axios"
import AppSetting from "../../common/constants/appsetting.constant"
import CommonService from "./common.service"

const ReportService = {
    getEmployeeWorkTicket(providerId, practiceLocationId, reqObj) {
        let loggedInUserData = this.getLoggedInData()
        let url = AppSetting.reports.getEmployeeWorkTicket.replace('{parentId}', loggedInUserData.parentId).replace('{providerId}', providerId).replace('{locationId}', practiceLocationId)
        if (reqObj !== {}) {
            url = `${url}${this.buildQuery(reqObj)}`
        }
        return axios.get(url)
            .then(res => {
                console.log(res)
                return res.data
            })
            .catch(err => {
                return err
            })
    },
    getEmployeeSalesReport(reqObj) {
        let loggedInUserData = this.getLoggedInData()
        let url = AppSetting.reports.getEmployeeSalesReport.replace('{parentId}', loggedInUserData.parentId)
        url = `${url}${this.buildQuery(reqObj)}`
        return axios.get(url)
        .then(res=>{
            return res.data
        })
        .catch(err=>{
            return err
        })
    },
    getMembershipReportReport(reqObj) {
        let loggedInUserData = this.getLoggedInData()
        let url = AppSetting.reports.getMembershipReport.replace('{parentId}', loggedInUserData.parentId)
        url = `${url}${this.buildQuery(reqObj)}`
        return axios.get(url)
        .then(res=>{
            return res.data
        })
        .catch(err=>{
            return err
        })
    },
    getFinancialBenchmarkReport(reqObj) {
        let loggedInUserData = this.getLoggedInData()
        let url = AppSetting.reports.getFinancialBenchmarkReport.replace('{parentId}', loggedInUserData.parentId)
        url = `${url}${this.buildQuery(reqObj)}`
        return axios.get(url)
        .then(res=>{
            return res.data
        })
        .catch(err=>{
            return err
        })
    },
    getEmployeeSalesSummary(reqObj) {
        let loggedInUserData = this.getLoggedInData()
        let url = AppSetting.reports.getEmployeeSalesSummary.replace('{parentId}', loggedInUserData.parentId)
        url = `${url}${this.buildQuery(reqObj)}`
        return axios.get(url)
        .then(res=>{
            return res
        })
        .catch(err=>{
            return err
        })
    },
    getReconciliationReport(reqObj){
        let loggedInUserData = this.getLoggedInData()
        let url = AppSetting.reports.getReconciliationReport.replace('{parentId}', loggedInUserData.parentId)
        url = `${url}${this.buildQuery(reqObj)}`
        return axios.get(url)
        .then(res=>{
            // console.log(res)
            return res.data
        })
        .catch(err=>{
            return err
        })
    },
    getPatientsLifeTimeValueReport(reqObj) {
        let loggedInUserData = this.getLoggedInData()
        let url = AppSetting.reports.getLifeTimeValueReport.replace("{parentId}", loggedInUserData.parentId)
        url = `${url}${this.buildQuery(reqObj)}`
        return axios.get(url)
            .then(res => { return res.data })
            .catch(err => { return err })
    },
    getManufacturerSummaryReport(reqObj) {
        let loggedInUserData = this.getLoggedInData()
        let url = AppSetting.reports.getManufacturerSummaryReport.replace('{parentId}', loggedInUserData.parentId)
        url = `${url}${this.buildQuery(reqObj)}`
        return axios.get(url)
        .then(res=>{
            return res.data
        })
        .catch(err=>{
            return err
        })
    },
    buildQuery(reqObj) {
        return CommonService.buildQuery(reqObj)
    },
    getLoggedInData() {
        return CommonService.getLoggedInData()
    }
}

export default ReportService